import React from 'react';
import { useNavigate } from 'react-router-dom';
import CommonLayout from '../../layouts/CommonLayout';
import LocationSelectionContainer from "../../containers/LocationSelectionContainer";
import LoadingOverlay from '../../layouts/LoadingOverlay';
import { me } from '../../../api/MemberApi';
import useAuthStore from '../../../store/authStore';

const LocationSelectionPage = () => {
    const navigate = useNavigate();
    const { setMember } = useAuthStore();

    const handleLocationSaved = async () => {
        try {
            // 멤버 정보 업데이트
            const updatedMember = await me();
            setMember(updatedMember);

            navigate('/app/mypage', { replace: true });
        } catch (error) {
            console.error('위치 업데이트 실패:', error);
            navigate('/app/mypage', { replace: true });
        }
    };

    return (
        <>
            <CommonLayout
                title="내 위치 설정"
                showBackButton={true}
            >
                <div className="h-[calc(100vh-65px)]">
                    <LocationSelectionContainer onLocationSaved={handleLocationSaved} />
                </div>
            </CommonLayout>
            <LoadingOverlay />
        </>
    );
};

export default LocationSelectionPage;
